import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import PropTypes from "prop-types";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";
import {Card, Col, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import TextInput from "../input/TextInput";
import QRBarInput from "../input/QRBarInput";

export default class AssemblyControllerFWVersionFormCard extends BaseComponent{

    constructor(props) {
        super(props);
        let {assembly} = this.props
        if(isEmpty(assembly)){
            assembly = {}
        }
        this.setState({assembly})
        this.fwVersionRef = React.createRef()
        this.controllerRef = React.createRef()
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {assembly} = nextProps
            if(isEmpty(assembly)){
                assembly = {}
            }
            this.setState({assembly})
        }
    }

    start(){
        setTimeout(()=>{
            let fwVersionInput = this.fwVersionRef.current
            if(fwVersionInput){
                fwVersionInput.callFocus()
            }
        }, 300)
    }

    render() {
        let {assembly} = this.state
        let {onPassed} = this.props
        onPassed = onPassed || (()=>{})
        if(isEmpty(assembly)){
            assembly = {}
        }
        let {updateProperties} = this.props
        if(!updateProperties){
            updateProperties = () => {}
        }
        return (
            <Card border="light" className="bg-white shadow-sm mb-4">
                <Card.Header>
                    {label.FWVersion} {label.And} {label.Controller}
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col xs={12} lg={6} className="text-left">
                            <QRBarInput
                                label={label.FWVersion}
                                icon={faCode}
                                value={assembly.fwVersion}
                                capitalized={true}
                                ref={this.fwVersionRef}
                                onChange={(value) => {
                                    updateProperties('fwVersion', value)
                                }}
                                onFilled={(value) => {
                                    if(this.controllerRef.current){
                                        this.controllerRef.current.callFocus()
                                    }
                                }}
                            />
                        </Col>
                        <Col xs={12} lg={6} className="text-left">
                            <QRBarInput
                                label={label.Controller}
                                icon={faCode}
                                value={assembly.controller}
                                capitalized={true}
                                ref={this.controllerRef}
                                onChange={(value) => {
                                    updateProperties('controller', value)
                                }}
                                onFilled={() => {
                                    onPassed()
                                }}
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }

}

AssemblyControllerFWVersionFormCard.propTypes = {
    assembly : PropTypes.any,
    updateProperties : PropTypes.func.isRequired,
    onPassed : PropTypes.func
}